import {useCollapsedKeys} from '@/hooks';

const STORAGE_KEY = 'guest:collapsedFirms';

/** Which firm cards the guest folded, remembered in the browser; every firm starts expanded. */
export function useGuestCollapsedFirms() {
  return useCollapsedKeys(STORAGE_KEY);
}
